import {IMLStatusResponse} from "../../../models/IMLMonitor";
import {appAPI} from "../../../api";

const basePath = `/ml`;

export const mlMonitorAPI = {
    getStatus: async (signal?: AbortSignal): Promise<IMLStatusResponse> => {
        const res = await appAPI.get(`${basePath}/status`, {signal});
        return res.data;
    },

    markRead: async (predictionId: string): Promise<void> => {
        await appAPI.patch(`${basePath}/predictions/${predictionId}/read`);
    },
};
